import styled from "styled-components";
export const ProfileContainer = styled.div`
  .form-item {
    margin-bottom: 24px;
  }
  .type-selector {
    display: flex;
    .item {
      width: 50%;
      text-align: center;
      background: #dce5e5;
      font-size: ${({ theme }) => theme.sizes.font2};
      padding: 8px 0 4px 0;
      cursor: pointer;
      &:first-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      &:last-child {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }
    }
    .active {
      background: ${({ theme }) => theme.colors.btnPrimaryBg};
      color: #fff;
      cursor: default;
    }
  }
  .buttons {
    direction: ltr;
  }
  @media only screen and (max-width: 760px) {
    .form-item {
      margin-bottom: 12px;
    }
  }
`;
